import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const Resources: ParentMenuProps = {
  label: 'Resources',
  description: 'Tools, insights, and advice',
  heapClass: 'ca_topnav_resources',
  gridCols: 'grid-cols-4 xl:grid-cols-8 min-[1440px]:ml-[108px]',
  showcaseMobile: true,
  subMenus: [
    {
      label: 'About',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: "Learn about Toast's mission to help restaurants thrive.",
          heapClass: 'ca_nav_about',
          icon: 'before:content-icon-info',
          url: '/about'
        }
      ]
    },
    {
      label: 'Customer Stories',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Restaurants of all kinds finding success with Toast',
          heapClass: 'ca_nav_cxstories',
          icon: 'before:content-icon-solutions-back-of-house',
          url: '/customers'
        }
      ]
    },
    {
      label: 'Blog',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Resources to help restaurant people run great businesses.',
          heapClass: 'ca_nav_blog',
          icon: 'before:content-icon-other-blog',
          url: '/blog/on-the-line'
        }
      ]
    },
    {
      label: 'Refer a Restaurant',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Spread the word about Toast in Canada and get rewarded.',
          heapClass: 'ca_nav_refer',
          icon: 'before:content-icon-partners',
          url: '/events/referral'
        }
      ]
    },
    {
      label: 'Free Tools and Templates',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label:
            'Guides, e-books, and templates designed to help you run your restaurant business better.',
          heapClass: 'ca_nav_resources',
          icon: 'before:content-icon-resource-2',
          url: '/resources'
        }
      ]
    },
    {
      label: 'Toast vs Other POS',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Compare Toast with other POS systems.',
          heapClass: 'ca_nav_compare',
          icon: 'before:content-icon-resource-2',
          url: '/compare'
        }
      ]
    }
  ]
}

export default Resources
